import {
  CategoryDto,
  NaraDto,
  ProductCompletionRequest,
  ProductCompletionResponse,
  ProductDto,
  SubshopProductCompletionResponseDto
} from '@eurogast/hub-client-typescript';

export default interface ProductCompletionService {
  completeProducts(completionBody: ProductCompletionRequest): Promise<AutoCompleteResponse>;
}

export class AutoCompleteResponse {
  public products: ProductDto[];
  public categories: CategoryDto[];
  public naras: NaraDto[];
  public totalNumberOfElements: number;

  private constructor(
      products: ProductDto[],
      categories: CategoryDto[],
      naras: NaraDto[],
      totalNumberOfElements: number
  ) {
    this.products = products;
    this.categories = categories;
    this.naras = naras;
    this.totalNumberOfElements = totalNumberOfElements;
  }

  public static emptyResponse() {
    return new AutoCompleteResponse(
      [], [], [], 0
    );
  }

  public static fromDefaultResponse(defaultResponse: ProductCompletionResponse): AutoCompleteResponse {
    return new AutoCompleteResponse(
      defaultResponse.products,
      defaultResponse.categories,
      [],
        defaultResponse.totalNumberOfProductsFound
    );
  }

  public static fromSubshopResponse(subshopResponse: SubshopProductCompletionResponseDto): AutoCompleteResponse {
    return new AutoCompleteResponse(
      subshopResponse.completionResponse.products,
      subshopResponse.completionResponse.categories,
      subshopResponse.naras,
      subshopResponse.completionResponse.totalNumberOfProductsFound
    );
  }
}
